export default __webpack_public_path__ + "static/media/cancelRed.42750eac.svg";